import React from 'react'
import Typography from 'material-ui/Typography'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import Input, {InputLabel} from 'material-ui/Input'
import {FormControl, FormHelperText} from 'material-ui/Form'
import {ModalHeader, ModalContents, ModalFooter} from '../../../common/modal'

import {withStyles} from 'material-ui/styles'
import styles from './styles'

class UploadLT4AdapterPolicy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      adapterpolicyfile: null,
      errors: {}
    }
  }

  handleChange = e => {
    let errors = {...this.state.errors}
    if (e.target.type === 'file' && e.target.files.length) {
      let fileExtension = e.target.files[0].name.split('.').pop();
      if (fileExtension === 'csv') {
        this.setState({
          [e.target.name]: e.target.files[0],
          errors: {
            ...errors,
            [e.target.name]: false
          }
        })
      } else {
        this.setState({
          errors: {
            ...errors,
            [e.target.name]: true
          }
        })
      }
    }
  }

  uploadAdapterPolicyFile = e => {
    e.preventDefault()
    let csvFile = this.state.adapterpolicyfile
    if (csvFile) {
      const fd = new FormData();
      fd.append('file', csvFile)

      this.props.uploadAdapterPolicy(fd)
      this.props.onClose()
    }
  }

  render() {
    const {classes, translate, onClose} = this.props
    const {adapterpolicyfile, errors} = this.state
    return (
      <Modal open={true} onClose={onClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("settings_lt4adapter_policydb_title")}
              </Typography>
            </ModalHeader>
            <ModalContents>
              <form noValidate autoComplete="off" className={classes.form}>
                <FormControl
                  fullWidth
                  margin="normal"
                  error={!!errors.adapterpolicyfile}
                >
                  <InputLabel htmlFor="adapterpolicyfile" shrink={true}
                              disableAnimation={true}>{translate("settings_lt4adapter_policydb_label")}</InputLabel>
                  <Input
                    className={classes.upload}
                    id="adapterpolicyfile"
                    type="file"
                    name="adapterpolicyfile"
                    onChange={this.handleChange}
                    inputProps={{
                      accept: ".csv",
                      name: "adapterpolicyfile"
                    }}
                  />
                  <FormHelperText
                    id="adapterpolicyfile-helper-text">{translate("settings_lt4adapter_policydb_help")}</FormHelperText>
                </FormControl>
              </form>
            </ModalContents>
            <ModalFooter>
              <Button raised
                      onClick={onClose}
              >
                {translate('general_cancel')}
              </Button>
              {adapterpolicyfile ? (<Button raised
                                            color="accent"
                                            type="submit"
                                            className={classes.submitButton}
                                            onClick={this.uploadAdapterPolicyFile}
              >
                {translate("settings_upload")}
              </Button>) : null}
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    )
  }
}

export default withStyles(styles)(UploadLT4AdapterPolicy)
